import carrierZoneModule from "../carrierZoneModule"

carrierZoneModule.controller("carrierZoneBlockedVehicleController", ["$scope", "sourceEntity", "entity", "carrierZoneBaseController", "carrierZoneBlockedVehicleService", ($scope, sourceEntity, entity, carrierZoneBaseController, carrierZoneBlockedVehicleService)=> {
    carrierZoneBaseController("carrier-zone-blocked-vehicles", $scope, sourceEntity, entity)
    carrierZoneBlockedVehicleService.findVehicles().then((vehicles) => $scope.vehicles = vehicles)
    carrierZoneBlockedVehicleService.findTrucks().then((trucks) => $scope.trucks = trucks)
}])